export default "__VITE_PUBLIC_ASSET__701908ac__"